import { jsx as _jsx } from "react/jsx-runtime";
import SecondaryButton from "segments/desktop/core-components/button/secondary-button/secondary-button";
import { BRAND_WORK_MANAGEMENT_PRIMARY_COLOR } from "styles/color-consts";
import { PRIVACY_NOTICE_URL, PRIVACY_NOTICE_TEXT } from "../../careers-constants.js";
const CandidatePrivacyNotice = ()=>{
    return /*#__PURE__*/ _jsx("div", {
        className: "candidate-privacy-notice",
        children: /*#__PURE__*/ _jsx(SecondaryButton, {
            color: BRAND_WORK_MANAGEMENT_PRIMARY_COLOR,
            buttonText: PRIVACY_NOTICE_TEXT,
            url: PRIVACY_NOTICE_URL,
            isOpenLinkInNewTab: true
        })
    });
};
export default CandidatePrivacyNotice;
